import { useQuery } from "react-query";
import ProductsService from "../api/services/ProductsService";

export const useStatesInfo = (queryKey: string, sc: string | null) => {
  const { data, isLoading, refetch, error } = useQuery(
    [queryKey, sc],
    async () => await ProductsService.getStatesInfo(sc),
    {
      enabled: !!sc
    }
  );

  return {
    stateData: data?.data?.state,
    isStateLoading: isLoading,
    stateError: error,
    fetchState: refetch
  }
}